// extracted by mini-css-extract-plugin
export default {"rCell":"TableRowCell_rCell__hvbOA","rCell__row":"TableRowCell_rCell__row__CT2Q+","rCell__item":"TableRowCell_rCell__item__FYMpW"};